var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWrongClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#C50F1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7066 16.7066C25.0973 16.316 25.0973 15.6816 24.7066 15.291C24.316 14.9004 23.6816 14.9004 23.291 15.291L20.0004 18.5848L16.7066 15.2941C16.316 14.9035 15.6816 14.9035 15.291 15.2941C14.9004 15.6848 14.9004 16.3191 15.291 16.7098L18.5848 20.0004L15.2941 23.2941C14.9035 23.6848 14.9035 24.3191 15.2941 24.7098C15.6848 25.1004 16.3191 25.1004 16.7098 24.7098L20.0004 21.416L23.2941 24.7066C23.6848 25.0973 24.3191 25.0973 24.7098 24.7066C25.1004 24.316 25.1004 23.6816 24.7098 23.291L21.416 20.0004L24.7066 16.7066Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWrongClose);
export default __webpack_public_path__ + "static/media/ic_wrong_close.3091bb422e1487e47b448661b77c9f6d.svg";
export { ForwardRef as ReactComponent };